import { observer } from "mobx-react-lite";
import { useFeatureFlag } from "src/contexts/posthog.context";
import { FLAGS } from "src/posthog/flags";
import type { Editor } from "src/types/Editor";
import { useFixtureExport } from "./useFixtureExport";

export const DevCostFixtureExport = observer(function DevCostFixtureExport(props: {
  editor: Editor;
}) {
  const enabled = useFeatureFlag(FLAGS.mapExport);
  const { busy, hasBuilding, worldHash, onClick } = useFixtureExport(props.editor);

  if (!enabled) return null;

  const label = busy ? "Exporting…" : "Export Fixture";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      title={hasBuilding ? `Fixture hash: ${worldHash}` : "No building — generate a design first"}
      className="absolute top-2 right-[80px] z-[99999] w-[120px] h-[28px] rounded-lg bg-purple-100 hover:bg-purple-50 hover:text-gray-400 text-white text-sm font-semibold shadow-lg disabled:opacity-50 flex items-center justify-center"
      data-testid="dev-export-cost-fixture"
    >
      {label}
    </button>
  );
});
